"use strict";

var _regeneratorRuntime = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/toConsumableArray");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadConfig = void 0;

var fs = require("fs");

var redocly_1 = require("../redocly");

var utils_1 = require("../utils");

var config_1 = require("./config");

var builtIn_1 = require("./builtIn");

function loadConfig(configPath, customExtends) {
  var _a, _b;

  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var rawConfig, redoclyClient;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (configPath === undefined) {
              configPath = findConfig();
            }

            rawConfig = {};

            if (!(configPath !== undefined)) {
              _context.next = 12;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return utils_1.loadYaml(configPath);

          case 6:
            rawConfig = _context.sent;
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            throw new Error("Error parsing config file at `".concat(configPath, "`: ").concat(_context.t0.message));

          case 12:
            if (customExtends !== undefined) {
              rawConfig.lint = rawConfig.lint || {};
              rawConfig.lint.extends = customExtends;
            }

            redoclyClient = new redocly_1.RedoclyClient();

            if (!redoclyClient.hasToken()) {
              _context.next = 30;
              break;
            }

            if (!rawConfig.resolve) rawConfig.resolve = {};
            if (!rawConfig.resolve.http) rawConfig.resolve.http = {};
            _context.t1 = "https://api.".concat(process.env.REDOCLY_DOMAIN || 'redoc.ly', "/registry/**");
            _context.t2 = undefined;
            _context.t4 = redoclyClient;

            if (!_context.t4) {
              _context.next = 24;
              break;
            }

            _context.next = 23;
            return redoclyClient.getAuthorizationHeader();

          case 23:
            _context.t4 = _context.sent;

          case 24:
            _context.t3 = _context.t4;

            if (_context.t3) {
              _context.next = 27;
              break;
            }

            _context.t3 = '';

          case 27:
            _context.t5 = _context.t3;
            _context.t6 = {
              matches: _context.t1,
              name: 'Authorization',
              envVariable: _context.t2,
              value: _context.t5
            };
            rawConfig.resolve.http.headers = [_context.t6].concat(_toConsumableArray((_a = rawConfig.resolve.http.headers) !== null && _a !== void 0 ? _a : []));

          case 30:
            return _context.abrupt("return", new config_1.Config(Object.assign(Object.assign({}, rawConfig), {
              lint: Object.assign(Object.assign({}, rawConfig === null || rawConfig === void 0 ? void 0 : rawConfig.lint), {
                plugins: [].concat(_toConsumableArray(((_b = rawConfig === null || rawConfig === void 0 ? void 0 : rawConfig.lint) === null || _b === void 0 ? void 0 : _b.plugins) || []), [builtIn_1.defaultPlugin])
              })
            }), configPath));

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
}

exports.loadConfig = loadConfig;

function findConfig() {
  if (fs.existsSync('.redocly.yaml')) {
    return '.redocly.yaml';
  } else if (fs.existsSync('.redocly.yml')) {
    return '.redocly.yml';
  }

  return undefined;
}